import { useState } from 'react';
import { useNavigate } from 'react-router';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';

import { api, useAPIContext } from '../../../api/context';
import urls from '../../../utils/urls';
import toast from '../../../utils/toast';
import Base from '../../Base';
import styles from './PayPal.module.scss';

const PayPal = () => {

  const { token } = useAPIContext();
  const [ loading, setLoading ] = useState(false);
  const { target } = urls.useTarget();

  const navigate = useNavigate();

  return (
    <Base title='PayPal'>
      <div className={styles.root}>
        <Formik
          initialValues={{
            email: '',
            email_confirm: '',
          }}
          validationSchema={yup.object({
            email: yup.string()
              .required('Required'),
            email_confirm: yup.string()
              .required('Required')
              .oneOf([yup.ref('email'), null], 'Confirmation must match'),
          })}
          onSubmit={(values, actions) => {

            if (loading) {
              return;
            }

            setLoading(true);

            api(token).v1.profile
              .update({ paypal: values.email })
              .then(res => {
                setLoading(false);

                if (res.status === 200) {
                  navigate(target);
                }

                if (res.status === 400) {
                  toast.show(toast.KIND.ERROR, res.body);
                }
              })
              .catch(err => {
                setLoading(false);
                toast.show(toast.KIND.WARNING, err);
              });

          }}
          >

          <Form>
            <p>
              Please enter your current or planned PayPal account email.
              You can edit this later.
            </p>

            <div>
              <Field
                autoFocus={true}
                aria-label='paypal email'
                placeholder='PayPal Email'
                name='email'
                type='email'
                disabled={loading}
              />
              <ErrorMessage
                name='email'
                component='div'
              />
            </div>

            <div>
              <Field
                aria-label='confirm paypal email'
                placeholder='Confirm PayPal Email'
                name='email_confirm'
                type='email'
                disabled={loading}
              />
              <ErrorMessage
                name='email_confirm'
                component='div'
              />
            </div>

            <button
              aria-label='save'
              type='submit'
              disabled={loading}>

              Save

            </button>
          </Form>

        </Formik>
      </div>
    </Base>
  );
};

export default PayPal;